import { apiClient } from '@/services/apiClient'

export function productImageEndpoint(productId: string): string {
  return `/api/commerce/products/${productId}/image`
}

export async function uploadProductImage(productId: string, file: File): Promise<Response> {
  const fd = new FormData()
  fd.append('file', file)
  return apiClient.fetch(productImageEndpoint(productId), { method: 'POST', body: fd })
}

export async function deleteProductImage(productId: string): Promise<Response> {
  return apiClient.fetch(productImageEndpoint(productId), { method: 'DELETE' })
}
